export const headerData = {
  name: 'Ayush Kumar Shukla',
  title: 'Hello! I am',
  desciption: `Hi, I'm Ayush—a passionate programmer and quick learner with a drive for problem-solving and exploring new technologies.`,
  //TODO
  image:
    'https://res.cloudinary.com/dulyuvl3h/image/upload/c_pad,b_auto:predominant,fl_preserve_transparency/v1696864356/my_img_b081rm.jpg?_s=public-apps',
  imagebw:
    'https://res.cloudinary.com/dulyuvl3h/image/upload/c_pad,b_auto:predominant,fl_preserve_transparency/v1696864356/my_img_b081rm.jpg?_s=public-apps',
  resumePdf:
    'https://drive.google.com/file/d/16c_3rey3mkGTxxAQputdnWOmWG3sHZZo/view',
  notes: 'https://sd-learning.netlify.app/docs/A-intro',
};
